/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "../../../../node_modules/@mui/material/Paper/Paper";
import jobStyles from "./jobStyles";
import TextContainer from "../../Container/TextContainer";

const SendApplication = ({ to }: { to: string }) => {
  return (
    <TextContainer sx={jobStyles.container}>
      <Paper sx={jobStyles.sendApplicationBox}>
        Sende Deine Bewerbungsunterlagen an
        <br />
        {to}
        <br />
        <a href={"mailto:jobs@legalbird.de"}>jobs@legalbird.de</a>
      </Paper>
      <br />
      <br />
    </TextContainer>
  );
};

export default SendApplication;
